module.exports = __webpack_public_path__ + "static/media/facebook.e2d57020.svg";